import UserEvent from './UserEvent';

type EventData = {
  errorMessage: string;
  errorType: string;
  isBot: boolean;
  pageType: string;
  url: string;
};

class PageLoadErrorEvent extends UserEvent<EventData> {
  collectServerEvents() {
    this.serverEvents.push({
      data: {
        error_message: this.data.errorMessage,
        error_type: this.data.errorType,
        page_type: this.data.pageType,
        url: this.data.url
      },
      type: 'page_load_error'
    });
  }
}

export default PageLoadErrorEvent;
